export const COLUMN = 'COLUMN';
